// detect user env
// if this script will be not enough u can replace it with "bowser" or any other lib (we have old version of bowser in vendors folder but its not enough to detect system and system version, new version support it but too much code needs to be saved in vendor, we can update it when we start use dependencies)
function detectUserEnv() {

  var browser,
      version,
      mobile,
      os,
      osversion,
      ua = window.navigator.userAgent,
      platform = window.navigator.platform;

  if ( /MSIE/.test(ua) ) {

    browser = 'Internet Explorer';

    if ( /IEMobile/.test(ua) ) {
      mobile = 1;
    }

    version = /MSIE \d+[.]\d+/.exec(ua)[0].split(' ')[1];

  } else if ( /Chrome/.test(ua) ) {
    // Platform override for Chromebooks
    if ( /CrOS/.test(ua) ) {
      platform = 'CrOS';
    }

    browser = 'Chrome';
    version = /Chrome\/[\d\.]+/.exec(ua)[0].split('/')[1];

  } else if ( /Opera/.test(ua) ) {

    browser = 'Opera';

    if ( /mini/.test(ua) || /Mobile/.test(ua) ) {
      mobile = 1;
    }

  } else if ( /Android/.test(ua) ) {

    browser = 'Android Webkit Browser';
    mobile = 1;
    os = /Android\s[\.\d]+/.exec(ua)[0];

  } else if ( /Firefox/.test(ua) ) {

    browser = 'Firefox';

    if ( /Fennec/.test(ua) ) {
      mobile = 1;
    }
    version = /Firefox\/[\.\d]+/.exec(ua)[0].split('/')[1];

  } else if ( /Safari/.test(ua) ) {

    browser = 'Safari';

    if ( (/iPhone/.test(ua)) || (/iPad/.test(ua)) || (/iPod/.test(ua)) ) {
      os = 'iOS';
      mobile = 1;
    }

  }

  if ( !version ) {

    version = /Version\/[\.\d]+/.exec(ua);

    if (version) {
      version = version[0].split('/')[1];
    } else if (/Opera/.test(ua)) {
      version = /Opera\/[\.\d]+/.exec(ua)[0].split('/')[1];
    } else if (/CriOS/.test(ua)) {
      version = /CriOS\/[\.\d]+/.exec(ua)[0].split('/')[1];
    } else {
      version = 'unknown version'
    }
  }

  if ( platform === 'MacIntel' || platform === 'MacPPC' ) {
    os = 'Mac OS X'
    var matches = /10[\.\_\d]+/.exec(ua);
    if (matches !== null) {
      osversion = matches[0];
    } else {
      osversion = "unknown version"
    }
    if ( /[\_]/.test(osversion) ) {
      osversion = osversion.split('_').join('.');
    }
  } else if ( platform === 'CrOS' ) {
    os = 'ChromeOS';
  } else if ( platform === 'Win32' || platform == 'Win64' ) {
    os = 'Windows';
  } else if ( !os && /Android/.test(ua) ) {
    os = 'Android';
  } else if ( !os && /Linux/.test(platform) ) {
    os = 'Linux';
  } else if ( !os && /Windows/.test(ua) ) {
    os = 'Windows';
  }

  return {
    browser : browser,
    version : version,
    mobile : mobile,
    os : os,
    osversion : osversion,
  };
}

function runDetectUserEnv() {
  try {
    return detectUserEnv();
  } catch (e) {
    console.error('failed to detect user agent: ', e);
  }

  return {
    browser : "FlippAvroDefault",
    version : "FlippAvroDefault",
    mobile : 0,
    os : "FlippAvroDefault",
    osversion : "FlippAvroDefault"
  };
}

export default runDetectUserEnv;
